<template>
  <buscadorpersona />
</template>

<script>

import buscadorpersona from '@/views/components/persona/buscador.vue'

export default {
  components: {
    buscadorpersona,
  },
  setup() {
    return {

    }
  },
}
</script>
